import { render, staticRenderFns } from "./WidgetConcordanceEntries.vue?vue&type=template&id=d0c7ce4a&scoped=true&"
import script from "./WidgetConcordanceEntries.vue?vue&type=script&lang=js&"
export * from "./WidgetConcordanceEntries.vue?vue&type=script&lang=js&"
import style0 from "./WidgetConcordanceEntries.vue?vue&type=style&index=0&id=d0c7ce4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c7ce4a",
  null
  
)

component.options.__file = "WidgetConcordanceEntries.vue"
export default component.exports